import React from 'react'

const Manual_admin_caja_registradora = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
    <div className="mt-16">
      <h2 className="font-bold xl-text-[40px] lg:text-4xl md:text-4xl text-4xl text-[#002D33] mb-5">
        Admin - Caja Registradora
      </h2>
      <p className="text-lg text-gray-700 mb-6">
        Esta guía ofrece un paso a paso para configurar una caja registradora en un sistema POS, incluyendo la configuración de impresoras, personalización de facturación y automatización de propinas e impuestos. Su uso garantiza un funcionamiento eficiente y optimiza la operación del negocio.
      </p>
      <iframe
        src="https://scribehow.com/embed/Admin__Caja_Registradora__Cnao38-vRESD69np2vWctw?as=scrollable"
        className="scribe-iframe-general-31"
        width="100%"
        height="5450"
        allowFullScreen
        style={{ border: 0, minHeight: '640px' }}
      ></iframe>
    </div>
  </div>
  )
}

export default Manual_admin_caja_registradora